var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"lazyload",style:({ minHeight: _vm.refinedMinHeight + 'px', opacity: _vm.loaded ? 1 : 0 })},[(_vm.loaded)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }